import { HDate, months } from '@hebcal/core';

/**
 * The daily Tanya cycle runs from 19 Kislev through 18 Kislev of the following
 * year. Whether a date's portion follows the "leap" or "regular" division
 * depends on the cycle's ANCHOR year — the Hebrew year of the 19 Kislev that
 * opened the cycle — NOT on the civil Hebrew year of the date being displayed.
 *
 * This distinction only matters at the tail of every cycle: the months Tishrei,
 * Cheshvan and Kislev (days 1–18) fall in the *next* Hebrew year, whose leap
 * status can differ from the anchor year's. Selecting the dataset by the current
 * year's leap status (instead of the anchor year's) serves the wrong portion for
 * those days — e.g. Cheshvan 5785 belongs to the leap cycle that started 19
 * Kislev 5784, even though 5785 itself is a regular year.
 *
 * @param {Date|HDate} date
 * @returns {{ yearType: 'leap'|'regular', monthName: string, day: number, anchorYear: number }}
 */
export function getTanyaCycle(date) {
  const hDate = date instanceof HDate ? date : new HDate(date);
  const year = hDate.getFullYear();

  // The cycle containing this date opened on the most recent 19 Kislev. Within a
  // Hebrew year, 19 Kislev falls after Tishrei/Cheshvan, so any date earlier than
  // it belongs to the cycle that began the previous year.
  const kislev19 = new HDate(19, months.KISLEV, year);
  const anchorYear = hDate.abs() >= kislev19.abs() ? year : year - 1;

  return {
    yearType: HDate.isLeapYear(anchorYear) ? 'leap' : 'regular',
    monthName: HDate.getMonthName(hDate.getMonth(), year),
    day: hDate.getDate(),
    anchorYear,
  };
}
